module.exports = __webpack_public_path__ + "assets/img/about-banner.b9f86d59.png";